import { useState } from 'react'
import { Modal, Button, Col } from 'react-bootstrap'
import { useCbuData } from '../../../../hooks/useCbuData'
import { BiInfoCircle } from 'react-icons/bi'
import toast from 'react-hot-toast'
import { createButton } from '../../../../API/Buttons/Buttons'
import { AdminUser } from '../../../../API/AdminInfo/models'

interface Props {
    show: boolean
    onHide: () => void
    adminInfo: AdminUser | null
}



export const NewButtonModal = ({ show, onHide, adminInfo }: Props) => {
    const { cbuData } = useCbuData()
    const [text, setText] = useState('')

    const [form, setForm] = useState({
        category: 'bienvenida',
        name: ''
    })


    const handleSave = async () => {
        if (!text) {
            toast.error('El texto no puede estar vacío')
            return
        }

        if (!form.name) {
            toast.error('El nombre no puede estar vacío')
            return
        }

        const response = await createButton({ category: form.category, messages: [text], name: form.name })

        if (response === 'done') {
            toast.success('Botón creado correctamente')
            onHide()
        } else {
            const errorMessage = response?.response?.data?.msg ?? 'Error al crear el botón'
            toast.error(errorMessage)
        }



    }

    return (
        <Modal show={show} onHide={onHide} size='lg' centered>
            <Modal.Header closeButton>
                <Modal.Title>Nuevo Botón</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-column gap-2 p-3'>
                    <div>
                        <Col md={6} sm={12}>

                            <div className='gap-2'>
                                <label htmlFor='text' className='text-primary text-xs'>
                                    Nombre
                                </label>
                            </div>
                            <input className='form-control' value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                        </Col>
                    </div>
                    <div>
                        <Col md={6} sm={12}>

                            <div className='gap-2'>
                                <label htmlFor='text' className='text-primary text-xs'>
                                    Categoría
                                </label>
                            </div>
                            <select className='form-control' value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
                                <option value='bienvenida'>Bienvenida</option>
                                <option value='info'>Info</option>
                                <option value='premios'>Premios</option>
                                <option value='fichas'>Fichas</option>
                                <option value='extra'>Extras</option>

                            </select>
                        </Col>
                    </div>
                    <div>
                        <div className='gap-2'>
                            <label htmlFor='text' className='text-primary text-xs'>
                                Mensaje
                            </label>
                        </div>
                        <textarea className='form-control' style={{ minHeight: '120px' }} value={text} onChange={(e) => setText(e.target.value)} />
                    </div>
                </div>



                <hr />
                <div className='mt-4 text-center text-secondary'>
                    <div className='d-flex align-items-center justify-content-center gap-1 text-xs'>
                        <BiInfoCircle size={15} />
                        <span className='text-center'>Puedes usar las variables en tus mensajes para que sean dinámicos, por ejemplo:</span>
                    </div>
                    <div className='mt-1 text-xs'>
                        Binvenido, el CBU es __CBU__, y el alias es __ALIAS__, estará disponible hasta las __HORA__
                    </div>
                </div>
                <div className="mt-3">
                    <div className="mb-2">Variables disponibles:</div>
                    <div><code>__CBU__</code>: {cbuData?.CBU || 'Consultar CBU'}</div>
                    <div><code>__ALIAS__</code>: {cbuData?.alias || 'Consultar alias'}</div>
                    <div><code>__TITULAR__</code>: {cbuData?.titular || 'Consultar titular'}</div>
                    <div><code>__HORA__</code>: {cbuData?.hour_limit || 'Consultar'}</div>
                    <div><code>__LINK__</code>: {adminInfo?.pageLink || 'Consultar'}</div>
                    <div><code>__PASSWORD__</code>: {adminInfo?.default_users_password ?? 'hola123'}</div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
                <Button variant="primary" onClick={() => {
                    handleSave()
                }}>
                    Crear
                </Button>


            </Modal.Footer>
        </Modal>
    )
}
